import { render } from "./Register.vue?vue&type=template&id=6902f8c4&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=6902f8c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6902f8c4"

export default script